<template>
  <v-container>
    <v-card>
      <v-card-text>
        <h1>{{ selectedInformGrroup.name }}</h1>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-textarea
            v-model="InformMessage.body"
            outlined
            dense
            label="*متن پیام"
            required
            :rules="[(v) => !!v || 'ثبت  متن الزامی می‌باشد']"
          ></v-textarea>
          <v-select
            v-model="InformMessage.informMessageType"
            item-value="title"
            item-text="displayName"
            placeholder="نوع پیام انتخاب شود "
            outlined
            label="نوع پیام    "
            dense
            required
            :rules="[(v) => !!v || 'نوع پیام الزامی می‌باشد']"
            :items="informMessageTypes"
          />

          <div dir="rtl">
            <v-select
              v-model="informMessagingType"
              item-value="title"
              item-text="displayName"
              placeholder="نوع مخاطبان انتخاب شود "
              outlined
              label="نوع مخاطبان    "
              dense
              :items="informMessagingTypes"
             
            />
          </div>

          <v-row v-if="informMessagingType == 'SpecifiedUsers'">
            <v-card>
              <v-card-text>
                <v-row>
                  <v-text-field
                    class="mt-3 font-weight-bold"
                     :rules="[
                    (v) => {
                      if (!v) {
                        return 'وارد کردن مقدار الزامی میباشد';
                      } else if (v && !/^(\d{11,11})+$/.test(v)) {
                        return 'تلفن حتما باید عدد و 11 رقم باشد';
                      }


                      else return true;
                    },
                  ]"
                 
                    counter
                    shaped
                    maxlength="11"
                    v-model="phoneNumber"
                    type="number"
                    label="شماره"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    dense
                    @keypress="isNumber($event)"
                    @keyup.enter="addPhoneNumber()"
                  ></v-text-field>
                  <v-btn @click="addPhoneNumber()">+</v-btn>
                </v-row>
                <v-row>
                  <v-list dense v-if="tempUserDataList">
                    <v-subheader>شماره‌های اضافه شده</v-subheader>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, i) in tempUserDataList"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-phone</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-bold text-h6"
                            v-text="'0' + item.phoneNumber"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="font-weight-bold"
                            v-text="item.fullName"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn @click="removePhoneNumber(item.phoneNumber)">
                            <v-icon color="grey lighten-1">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
          <v-row v-else>
            <v-card width="100%">
              <v-card-text>
                <v-container fluid>
                  <v-select
                    v-model="selectedGroups"
                    :items="vendorGroupItems"
                    label="گروه‌های مورد نظر"
                    multiple
                    item-text="title"
                    item-value="id"
                    chips
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @mousedown.prevent @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              selectedGroups.length > 0 ? 'indigo darken-4' : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> انتخاب همه </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:append-item>
                      <v-divider class="mb-2"></v-divider>
                      <v-list-item disabled>
                        <v-list-item-avatar color="grey lighten-3">
                          <v-icon> mdi-food-apple </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content v-if="selectAllGroups">
                          <v-list-item-title>
                            Holy smokes, someone call the fruit police!
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content v-else-if="selectSomeGroup">
                          <v-list-item-title> تعداد گروهها </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ selectedGroups.length }}
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-content v-else>
                          <v-list-item-title>
                            گروهی انتخاب نکردید?
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            برو بالا و گروههای مورد نظر را انتخاب کن!
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-container>
              </v-card-text>
            </v-card>
          </v-row>
          <v-row>
            <v-text-field
              v-model="InformMessage.description"
              outlined
              dense
              label=" توضیحات "
            ></v-text-field>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn color="error" @click="closeModal()">انصراف</v-btn>
        <v-btn class="primary" @click="saveInformMessage()">ثبت</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import qs from 'qs';
import Helper from '@/core/helpers';
import { RepoFactory } from '@/baseRepository/Factory';

const notificationRepository = () => RepoFactory.get('notification');
const merchantRepository = () => RepoFactory.get('merchant');
const merchantsRepository = () => RepoFactory.get('merchants');
const authRepository = () => RepoFactory.get('auth');
const usersRepository = () => RepoFactory.get('users');

export default {
  components: {},
  props: {
    informgroupId: {
      type: String,
      default: null,
    },
    informMessageId: {
      type: String,
      default: null,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    selectedInformGrroup: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      checkUserByPhoneIsValid:false,
      informMessagingType: null,
      selectedGroups: [],
      vendorGroupItems: [],
      phoneNumber: '',
      valid: false,
      informMessageTypes: [
        { displayName: 'موضوعات آموزشی، وبینار', title: 'Vebinars' },
        { displayName: 'اطلاع رسانی', title: 'General' },
        { displayName: 'اطلاع رسانی نمایشگاه', title: 'Exhibition' },
        { displayName: 'اطلاع رسانی به وندور‌های خاص', title: 'VendorInform' },
      ],
      rolesItem: [],
      informMessagingTypes: [
        {
          title: 'MerchantVendors',
          displayName: 'تامین کنندگان(وندورها)',
        },
        {
          title: 'SpecifiedUsers',
          displayName: 'کاربران خاص',
        },
      ],
      stateItems: [],
      citiesList: [],
      limitationTypes: [],
      stateIds: [],
      cityIds: [],
      IndustrialCityIds: [],
      industrialParksItems: [],
      industrialParkIds: [],
      tempUserData: null,
      tempUserDataList: null,
      InformMessage: {
        informMessagingGroupId: null,
        body: '',
        vendorGroups:null,
        sendToAllVendorGroups:null,
        paternId: null,
        informMessageType: '',
        senderLineNo: null,
        userPhones: null,
        informMessagingType: null,
      },
      contactInfo: {
        phonesCount: 0,
        merchantList: [],
        phones: [],
      },
    };
  },
  computed: {
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    smsSenderLineNo() {
       return this.$store.getters.smsSenderLineNo;
    },
    selectSomeGroup() {
      return this.selectedGroups.length > 0 && !this.selectAllGroups;
    },
    icon() {
      if (this.selectAllGroups) return 'mdi-close-box';
      if (this.selectSomeGroup) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    selectAllGroups() {
      return this.selectedGroups.length === this.vendorGroupItems.length;
    },
    notificationBaseUrl() {
      return this.$store.getters.notificationBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    authBaseUrl() {
      return this.$store.getters.authBaseUrl;
    },
  },
  created() {
    this.clearFormData();
    this.getVendorGroups();
    this.InformMessage.informMessagingGroupId = this.informgroupId;
  },
  onMounted() {
    this.clearFormData();
  },
  methods: {
    clearFormData() {
      this.phoneNumber = '';
      this.valid = false;
      // this.informMessageTypes= []
      // this.rolesItem= []

      this.tempUserData = null;
      this.tempUserDataList = null;
      (this.InformMessage = {
        informMessagingGroupId: null,
        body: '',
        paternId: null,

        informMessageType: '',
        senderLineNo: this.smsSenderLineNo,

        userPhones: null,

        informMessagingType: null,
      }),
        (this.contactInfo = {
          phonesCount: 0,
          merchantList: [],
          phones: [],
        });
    },
    addPhoneNumber() {
      if (this.InformMessage.userPhones == null) {
        this.InformMessage.userPhones = [];
      }
      if (!this.checkUserByPhone(this.phoneNumber)) {
        this.$dialog.message.warning('شماره مورد نظر جزپ کاربران نیست ', {
          position: 'top-left',
        });
        return;
      }
      if (
        this.phoneNumber &&
        this.phoneNumber.length == 11 &&
        this.phoneNumber.substring(0, 1) == '0'
      ) {
        ///this.InformMessage.userPhones.push(this.phoneNumber);

        // this.phoneNumber = '';
        // this.tempUserData = null;
      }
    },
    removePhoneNumber(noZeroPhone) {
      let phone = '0' + noZeroPhone;
      if (phone && phone.length == 11) {
        let findedIndex = this.InformMessage.userPhones.findIndex(
          (el) => el == phone
        );

        this.InformMessage.userPhones.splice(findedIndex, 1);
        //console.log("this.InformMessage.userPhones",this.InformMessage.userPhones.length)
        let findedIndexForTempList = this.tempUserDataList.findIndex(
          (el) => el.phoneNumber == noZeroPhone
        );

        this.tempUserDataList.splice(findedIndexForTempList, 1);
        //console.log(" this.tempUserDataList", this.tempUserDataList.length)
      }
    },
    async checkUserByPhone(phoneNumber) {
      ///api/v1/users/byphone
      //console.log('fun check is going');

      await authRepository()
        .getUserByPhone(this.authBaseUrl, {}, { phoneNumber: phoneNumber })
        .then((res) => {
          console.log('this.tempUserData ', res.data);
          this.tempUserData = res.data;

          if (res.data) {
            if (this.tempUserDataList == null) {
              this.tempUserDataList = [];
            }
            this.tempUserDataList.push(res.data);
        
                this.InformMessage.userPhones.push(this.phoneNumber);

                // this.phoneNumber = '';
                // this.tempUserData = null;
               
            return true;
          }  
        })
        .catch((error) => {
          //Helper.handleErrors(error, this);
          return false;
        });
         return false;
    },

    closeModal() {
      this.clearFormData();
      this.clearFormData();
      this.$emit('closeModal', false);
    },

    // async getEnumsByName() {
    //   const loader = this.$loading.show();
    //   await enumsRepository()
    //     .getEnum("InformMessageType", this.notificationBaseUrl)
    //     .then((res) => {
    //       this.informMessageTypes = res.data;
    //       console.log("this.informMessageTypes",this.informMessageTypes)
    //     })
    //     .catch((error) => {
    //       Helper.handleErrors(error, this);
    //     });

    //   this.loading = false;
    //   loader.hide();
    // },
    async calculateContacts() {
      const loader = this.$loading.show();
      const params = {
        categoryIds: this.InformMessage.categoryIds,
      };
      //params.categoryIds = this.InformMessage.categoryIds;
      if (this.InformMessage.hasLocationLimitation) {
        if (
          this.InformMessage.limitationIds.length > 0 &&
          this.InformMessage.limitationType
        ) {
          params.limitationIds = this.InformMessage.limitationIds;
          params.limitType = this.InformMessage.limitationType;
        }
      }

      // console.log("this.InformMessage. this.InformMessage", params);
      await merchantsRepository()
        .getMerchantsUserPhoneByCategoryIds(
          this.merchantBaseUrl,
          {},
          params,
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.contactInfo.phonesCount = res.data.allUsersPhoneNumber.length;
          this.contactInfo.merchantList = res.data.merchantPermittedList;
          this.contactInfo.phones = res.data.allUsersPhoneNumber;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
      this.loading = false;
      loader.hide();
    },

    saveInformMessage() {
      this.InformMessage.informMessagingType = this.informMessagingType;
      if (this.selectedGroups?.length > 0) {
        this.InformMessage.vendorGroups = this.selectedGroups;
        this.InformMessage.sendToAllVendorGroups = null;
      }
      if (this.selectAllGroups) {
        this.InformMessage.sendToAllVendorGroups = true;
        this.InformMessage.vendorGroups = null;
      } else {
        this.InformMessage.sendToAllVendorGroups = null;
      }
   
       
      if (this.$refs.form.validate()) {
        this.InformMessage.senderLineNo = this.smsSenderLineNo;
        //Check if Creating or editing
        if (this.isEditing) {
          //Editing
          messagebody = this.InformMessage;
          //Id on header
          this.informMessageId;
        } else {
          //Creating
          const loader = this.$loading.show();
          //check validation

            console.log("this.InformMessage is:",this.InformMessage)
          notificationRepository()
            .addNewInformMessageByMerchant(  this.currentMerchant,  this.InformMessage, this.notificationBaseUrl)
            .then(() => {
              //this.closeForm();
              this.$dialog.message.success('پیام با موفقیت ثبت شد. ', {
                position: 'top-left',
              });
              this.clearFormData();
              this.closeModal();
            })
            .catch((err) => {
              Helper.handleErrors(err, this);
              loader.hide();
            })
            .finally(loader.hide());
        }
      }
    },
    isNumber(event) {
      let char = String.fromCharCode(event.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else event.preventDefault();
    },
    getVendorGroups() {
      const loader = this.$loading.show();
      const params = {
        PageNumber: 1,
        ItemsPerpage: 2000,
      };

      merchantRepository()
        .getVendorGroups(
          this.$store.getters.currentMerchant,
          this.merchantBaseUrl,
          {},
          params
        )
        .then((res) => {
          this.vendorGroupItems = [];
          this.vendorGroupItems = res.data.list;
          // console.log("res.data.list",res.data.list)
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllGroups) {
          this.selectedGroups = [];
        } else {
          this.selectedGroups = this.vendorGroupItems.slice();
        }
      });
    },
  },

  watch: {
    informMessagingType(value) {
     console.log("watch of value:",value)
      if (value=='SpecifiedUsers') {
        this.selectedGroups = [];
        this.InformMessage.vendorGroups = null;
      }
      else {
        console.log("Iside clear userPhoes1",this.InformMessage.userPhones)
        this.InformMessage.userPhones = null;
        console.log("Iside clear userPhoes2",this.InformMessage.userPhones)
      }
    },
 
  },

};
</script>
